import {
  FEATURE_TOGGLE_VOLUME_BASED_PRICES,
  useFeatureToggle,
} from '../../../../../feature-toggles'
import { useProductSearchResultItemContext } from '../../ProductSearchResultItemContext/productSearchResultItemContext'

export const useProductSearchShouldRenderVolumePricingLabel = (): boolean => {
  const {
    algoliaRecord: { best_offer },
  } = useProductSearchResultItemContext()

  const isVolumePricingFeatureEnabled = useFeatureToggle(
    FEATURE_TOGGLE_VOLUME_BASED_PRICES,
  )

  if (!best_offer) {
    return false
  }

  const hasVolumePricing = Boolean(
    best_offer.volume_based_prices && best_offer.volume_based_prices.length > 1,
  )

  return isVolumePricingFeatureEnabled && hasVolumePricing
}
